<template>
<div class="card">
    <!-- <div v-if="!isLoaded" class="content">
        <placeholder-content isLoad="true" />
    </div> -->
    <div v-if="isLoaded" class="card-header border-bottom mb-3">
        <h5 class="card-title text-uppercase">{{$t('Daily Total Sales')}}</h5>
    </div>
    <div class="card-body">
        <v-chart v-if="isLoaded" class="chart" :option="option" autoresize/>
    </div>
</div>
</template>

<script>
import {
    use
} from "echarts/core";
import {
    CanvasRenderer
} from "echarts/renderers";
import {
    BarChart
} from "echarts/charts";
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    ToolboxComponent,
} from "echarts/components";
import VChart, {
    THEME_KEY
} from "@/plugins/vue-echarts";
import moment from "moment";

import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
use([
    CanvasRenderer,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    ToolboxComponent,
    BarChart,
]);
import {
    localSave,
    localRead
} from "@/store/lang";
import {
    convertTimezone
} from "@/common/tenancy/convertTimezone.js";

export default {
    components: {
        VChart,
        PlaceholderContent
    },
    provide: {
        [THEME_KEY]: "default",
    },
    props: ['chartColumns'],
    data() {
        return {
            lang: localRead("local"),
            hasData: false,
            option: {
                textStyle: {
                    fontFamily: 'Sarabun',
                },
                tooltip: {
                    trigger: "axis",
                    textStyle: {
                        fontSize: 13,
                    },
                    axisPointer: {
                        type: "shadow",
                    },
                },
                grid: {
                    top: 40,
                    left: 15,
                    right: 15,
                    bottom: 0,
                    containLabel: true,
                },
                xAxis: [{
                    type: "category",
                    data: [],
                    axisTick: {
                        alignWithLabel: true,
                    },
                }, ],
                yAxis: {
                    name: this.$t("_Shipping.Number of Orders"),
                    type: "value",
                    nameTextStyle: {
                        align: "left",
                    },
                    splitLine: {
                        lineStyle: {
                            type: "dashed"
                        }
                    },
                    axisLabel: {},
                },
                legend: {
                    left: "right",
                    itemHeight: 10,
                    itemWidth: 10,
                },
                series: false,
            },
            isLoaded: false,
        };
    },
    async mounted() {
        let chartColumnsData = this.chartColumns.data;
        let chartColumnsSeries = this.chartColumns.series;
        let chartColumnsdateSeries = this.chartColumns.dateSeries;
        let formatDate = "";
            if(chartColumnsdateSeries == "MOUTHS"){
                formatDate = "MMM YYYY";
            } else {
                formatDate = "D MMM";
            }

            let series = [];
            for await (let data of chartColumnsSeries) {
                let start = data.start;
                this.option.xAxis[0].data.push(moment(start).locale(this.lang).format(formatDate));
                    // console.log('start:', moment(start).locale(this.lang).format(formatDate));
            }
            const color = ["#fd666d", "#03A9F4", "#FF9E1E"];

            for await (let data of chartColumnsData) {
                console.log(data)
                series.push({
                    name: this.$t(data.name),
                    type: "bar",
                    stack: "total",
                    barMaxWidth: 20,
                    barWidth: "80%",
                    barGap: "10%",
                    itemStyle: {
                        color: typeof color[data.id] != 'undefined' ? color[data.id] : '#37A2DA',
                    },
                    data: data.data,
                });

                var max_amount = data.data.reduce(function (a, b) {
                    return Math.max(a, b);
                }, 0);
                if (max_amount > 0) {
                    this.hasData = true;
                }
            };
        this.option.series = series;
        // console.log(this.option.series);
        this.isLoaded = true;
    },

    methods: {
    },
};
</script>

<style scoped>
.chart {
    height: 370px;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/product/ProductSalesChart.vue